import { render, staticRenderFns } from "./Youthtravel.vue?vue&type=template&id=776f7355&scoped=true&"
import script from "./Youthtravel.vue?vue&type=script&lang=js&"
export * from "./Youthtravel.vue?vue&type=script&lang=js&"
import style0 from "./Youthtravel.vue?vue&type=style&index=0&id=776f7355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f7355",
  null
  
)

export default component.exports